import React from "react";
import { SCHEDULE_SECTIONS } from "../DeviceSchedule/constants";
import {
  chipFields,
  formatField,
  isPending,
  sectionSides,
  statusOf,
  SYNC_LABEL,
  timestampField,
} from "../DeviceSchedule/function";
import { PendingIcon, fieldIcon } from "../DeviceSchedule/components/Icons";
import "../DeviceSchedule/DeviceSchedule.css";
import "./ScheduleStrip.css";

const PILL_CLASS = {
  active: "ds-pill ds-pill-active",
  inactive: "ds-pill ds-pill-inactive",
  unset: "ds-pill ds-pill-unset",
};

// One schedule (default or temporary) on one line, as Device Schedule's cell
// shows it: what the device reports, and a Pending badge while a sent change is
// not applied.
function ScheduleRow({ document, section }) {
  const { current, expected } = sectionSides(document, section);
  const pending = isPending(current, expected, section);
  const status = statusOf(current, section);
  const stamp = timestampField(section);
  const updated = stamp ? formatField(stamp, current) : null;
  // A temporary schedule that is not running has nothing worth reading in its
  // times and dates (they sit at zero), so it shows as just its status.
  const statusOnly = section.key === "temp" && status !== "active";

  return (
    <div className="dash-schedule-row" style={{ borderLeftColor: section.accent }}>
      <div className="dash-schedule-title">{section.label}</div>

      <span className={PILL_CLASS[status]}>{SYNC_LABEL[status]}</span>
      {pending && (
        <span className="ds-badge-pending" title="Sent to the device, not applied yet">
          <PendingIcon />
          Pending
        </span>
      )}

      {!statusOnly && (
        <div className="ds-chips dash-schedule-chips">
          {chipFields(section).map((field) => {
            const Icon = fieldIcon(field.type);
            const value = formatField(field, current);
            return (
              <span className="ds-chip" key={field.name}>
                <Icon />
                <span className="ds-chip-label">{field.label}</span>
                <span className={value ? "" : "ds-chip-empty"}>{value || "Not set"}</span>
              </span>
            );
          })}
        </div>
      )}

      {!statusOnly && (
        <span className="dash-schedule-stamp">
          {updated ? `Updated ${updated}` : "No update reported"}
        </span>
      )}
    </div>
  );
}

// The selected appliance's schedules - default and temporary - under the
// dashboard's filters, for appliances set to be scheduled. Read from the
// /details document the dashboard already has (no call of its own), and drawn
// with Device Schedule's pills and chips so the two pages read alike. Read
// only: schedules are changed on Device Schedule.
function ScheduleStrip({ document }) {
  return (
    <div className="dash-schedule">
      <div className="dash-schedule-rows">
        {SCHEDULE_SECTIONS.map((section) => (
          <ScheduleRow key={section.key} document={document} section={section} />
        ))}
      </div>
    </div>
  );
}

export default ScheduleStrip;
